export const environment = {
  production: true,
  api: {
    search: '/api/v1',
    history: '/history/api/v1',
  },
  keycloak: {
    url: 'https://auth.dev.agentic-system.tim.it/',
    realm: 'MinisteroDifesaAI',
    clientId: 'web-console',
  },
};
